
import Vue from 'vue'
import AnalyticsTab from "./AnalyticsTab"
import AnalyticsDataSource from '@/components/RightPaneComponents/AnalyticsDataSource';
import { required } from 'vuelidate/lib/validators'
import Chart from 'chart.js';

export default Vue.extend({
    components:{
        'analytics-tab':AnalyticsTab,
        'analytics-data-source':AnalyticsDataSource
    },
    name:"AnalyticsMain",
    data(){
        return {
            newDashboard:{
                name:"",
                description:""
            },
            selectedPresets:[] as Array<any>,
            activeTab: {} as any,
            busy:false,
            isUpdate: false,
            updatePresetId: null,
            analyticsStyles: {
                fontSize: 12,
                fontWeight: '400',
                textColor: '#a1a1a1',
                chartBackground: '#fff',
                dashboardBackground: '#fff',
            },
            selectedProjectId: ''
        }
    },
    validations: {
        newDashboard: {
            name: {required},
            description: {required},
        }
    },
    methods:{
        toggleSideNav(){
            this.$store.commit('setSideNav')
        },
        createNewDashboard(){
            ((this.$refs['new-dashboard-modal']) as any).show()
        },
        doDahboardCreation(){
            let tempId = Math.abs((Math.floor(Math.random() * (10 - +4000))  +10)+(Math.floor(Math.random() * (10 - +4000))  +10)); 
            this.$store.commit("Analytics/add",{id:tempId,name:this.newDashboard.name,description:this.newDashboard.description,kpIs:[]})
            this.selectedPresets.push(tempId)
            this.activeTab = tempId
            this.newDashboard.name = ""
            this.newDashboard.description = "";
            this.$v.$reset();
            ((this.$refs['new-dashboard-modal']) as any).hide()
        },
        doUpdateDashboard(){
            let presetIndex = this.savedPresets.findIndex(preset => preset.id === this.updatePresetId);

            if (presetIndex !== -1) {
                let updatedPreset = {
                    ...this.savedPresets[presetIndex],
                    name: this.newDashboard.name,
                    description: this.newDashboard.description
                };

                this.$store.commit("Analytics/updatePreset", updatedPreset);

                this.newDashboard.name = "";
                this.newDashboard.description = "";
                this.$v.$reset();

                ((this.$refs['update-dashboard-modal']) as any).hide();
                this.isUpdate = false;
            }
        },
        tabClicked(id:any){
            if(this.activeTab!=id){
                this.activeTab=id
            }
            this.$store.commit('setRightPaneToTrue');
        },
        logout(){
            this.$router.push("/")
            this.$store.dispatch("logOut")
        },
        help(){
            this.$router.push("/help")
        },
        savePresetChanges(){
            this.isUpdate = false
            this.busy = true
            this.$store.dispatch("Analytics/saveChanges").then(()=>{
                this.busy = false
                this.$store.commit("Analytics/clearPresetChanges")
            })
        },
        updatePreset(savedPreset: any){
            this.isUpdate = true
            this.updatePresetId = savedPreset.id;
            this.newDashboard.name = savedPreset.name;
            this.newDashboard.description = savedPreset.description;
            ((this.$refs['update-dashboard-modal']) as any).show()
        },
        deletePreset(presetId: number) {
            this.$store.commit("Analytics/deletePreset", presetId);
            this.selectedPresets = this.selectedPresets.filter(id => id !== presetId);
        },
        resetUpdateState() {
            this.newDashboard.name = "";
            this.newDashboard.description = "";
            this.$v.$reset();
            this.isUpdate = false;
        },
        handleStylesChanged(data: any) {
            this.analyticsStyles = data;
        },
        handleProjectChanged(data: any) {
            this.selectedProjectId = data
        }
    },
    computed:{
        savedPresets():Array<any>{
            return this.$store.getters['Analytics/getPresets']
        },
        computedSelectedPresets():Array<any>{
            return this.selectedPresets
                .map(presetId => this.savedPresets.find(sp => sp.id === presetId))
                .filter(preset => preset !== undefined);
        },
        sidenav():any{
            return this.$store.getters['getSideNavStatus']
        },
        activeUser():any{
            return this.$store.getters['activeUser']
        },
        rightPane():any{
            return this.$store.getters['getPaneStatus']
        },
        activePane():any{
            return this.$store.getters['getActivePane']
        },
        presetChanges():any{
            return this.$store.getters["Analytics/getPresetChangesCount"]
        }
    },
    mounted(){
        // this.$store.commit('setSideNavToFalse')
        this.$store.dispatch("Analytics/getKPIs")
        if(this.savedPresets.length<1)this.$store.dispatch("Analytics/getPresets")
    },
    beforeDestroy(){
        this.$store.commit('setRightPaneToFalse');
        this.$store.commit('setActivePane', '');
    }
})
